import CryptoJS from 'crypto-js'
import * as playTypes from 'src/store/modules/play/types'

// 暗号化のためのキーを生成
const pw = CryptoJS.SHA256('Odakyu-MusicMaker')
const key = pw.toString(CryptoJS.enc.Base64)

// パラメーター、アイテムの区切り文字
const delimiter = {
  value: ',',
  item: '|',
}

/**
 * スコアをクエリー文字列に変換
 * @param score
 */
export function scoreToQuery (score: playTypes.SoundOnScore[]) {
  // パラメーターをカンマ区切り→音をパイプ区切り→AES暗号化→URLエンコード
  const str = score.map((item) => {
    return [item.id, item.soundId, item.trackIndex, item.when].join(delimiter.value)
  }).join(delimiter.item)
  const encrypt = CryptoJS.AES.encrypt(str, key)

  return encodeURIComponent(encrypt.toString())
}

/**
 * クエリー文字列からスコアに変換
 * @param query クエリー文字列
 */
export function queryToScore (query: string): playTypes.SoundOnScore[] {
  // エンコードの逆
  // URLデコード→AES復号→パイプで分割（音）→カンマで分割（パラメーター）
  // 複合に失敗するときがあるのでtry catchで処理する
  try {
    const decrypted = CryptoJS.AES.decrypt(decodeURIComponent(query), key)
    const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8)
    const items = decryptedStr.split(delimiter.item)

    return items.map((item) => {
      const params = item.split(delimiter.value)
      return {
        id: Number(params[0]),
        soundId: String(params[1]) as playTypes.SoundId,
        trackIndex: Number(params[2]) as playTypes.TrackIndex,
        when: Number(params[3]),
      }
    })
  } catch (e) {
    // 複合失敗
    console.error('decrypt failure.', e)
    return []
  }
}
